import React from "react";
import CommentoContainer from "./CommentoContainer";
import styles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import { useComparisonLabels } from "../../compare/ComparisonLabelsContext";

type Props = {
  threadId: any;
  portfolio1Id: any;
  portfolio2Id: any;
};

const PortfolioCommentoCompare: React.FC<Props> = ({
  threadId,
  portfolio1Id,
  portfolio2Id,
}) => {
  const labels = useComparisonLabels();
  return (
    <div style={{ marginBottom: 10, marginLeft: 5 }}>
      <div style={{ marginBottom: 20 }}>
        <div className={styles.subSectionTitle} style={{ marginTop: 16 }}>
          {`Commento al ${labels.portfolio1.toLowerCase()}`}
        </div>
        <CommentoContainer threadId={threadId} portfolioId={portfolio1Id} />
      </div>
      <div className="force-page-break"></div>
      <div>
        <div className={styles.subSectionTitle} style={{ marginTop: 35 }}>
          {`Commento al ${labels.portfolio2.toLowerCase()}`}
        </div>
        <CommentoContainer threadId={threadId} portfolioId={portfolio2Id} />
      </div>
    </div>
  );
};

export default React.memo(PortfolioCommentoCompare);